import PrintingHeader from "../../../../src/components/PrintingHeader.js";
import * as React from 'react';
export default {
  PrintingHeader,
  React
};